import { SyncEventType } from '../../enums/syncEventType';
import { AiState } from '../../enums/aiState';
import { ChatEvent } from './chatEvent';

export class EventAiStateChanged implements ChatEvent {
  public readonly type = SyncEventType.AI_STATE_CHANGED;
  state: AiState;

  constructor(state: AiState) {
    this.state = state;
  }

  getPayload(): object {
    return { state: this.state };
  }
}
